import { IFeaturedImage, IPlatform } from '@/shared/types/existing-brands';

import { BreakpointsType } from '@/shared/types/typings';
import { FAQType } from '../types/subscription';
import { IMembershipCard } from '@/shared/types/existing-brands';
import { STATIC_FILE_URL } from '@/shared/constants';

export const FEATURE_BRANDS: IFeaturedImage[] = [
  { title: 'House Plant', link: `${STATIC_FILE_URL}/bd3d7c55cf646c988d10892201b2264b.png`, width: 250, height: 290 },
  { title: 'Bad Mouth', link: `${STATIC_FILE_URL}/4d5750bfe1acce76c72f90c26125cad2.png`, width: 250, height: 290 },
  { title: 'CBUMFITNESS', link: `${STATIC_FILE_URL}/e852689e60da6f8bbaa28fb5e8e74829.png`, width: 250, height: 290 },
  { title: 'Arrae', link: `${STATIC_FILE_URL}/1196a4f7e374be784d8d39e311f39845.png`, width: 250, height: 290 },
  { title: 'Curie', link: `${STATIC_FILE_URL}/0db718edd3d6ed8666ce912e6e9a8d33.png`, width: 250, height: 290 },
  { title: 'Wellthy', link: `${STATIC_FILE_URL}/0912c2d5c4e3eeff29398f29e581a4af.png`, width: 250, height: 290 },
];

export const EXISTING_BRANDS_FEATURED_IN_CONTENT: IFeaturedImage[] = [
  {
    title: 'As featured in',
    link: `${STATIC_FILE_URL}/c5d527b188a35e79cec7eaf2b98ea434.png`,
    width: 104,
    height: 19,
  },
  {
    title: 'Tech Crunch 1',
    link: `${STATIC_FILE_URL}/d65e5b8989922fa0f958538d63bab6cd.svg`,
    width: 138,
    height: 20,
  },
  {
    title: 'CNBC 1',
    link: `${STATIC_FILE_URL}/685fc58e16b7ac581252464f998b0925.png`,
    width: 40,
    height: 32,
  },
  {
    title: 'Business Insider 1',
    link: `${STATIC_FILE_URL}/a7235f4c38c1500aa22b8894c2ead6a8.png`,
    width: 77,
    height: 24,
  },
  {
    title: 'Forbes 1',
    link: `${STATIC_FILE_URL}/4b7c20eb379918c86e22bc003e8d4ab3.png`,
    width: 61,
    height: 16,
  },
  {
    title: 'Modern Retail 1',
    link: `${STATIC_FILE_URL}/dc81365e388b399ba01a157697239ce5.png`,
    width: 152,
    height: 20,
  },
  {
    title: 'New Bloomberg 1',
    link: `${STATIC_FILE_URL}/4a75f21285efb990682c7f36160b063f.png`,
    width: 130,
    height: 24,
  },
  {
    title: 'Tech Crunch 2',
    link: `${STATIC_FILE_URL}/d65e5b8989922fa0f958538d63bab6cd.svg`,
    width: 138,
    height: 20,
  },
  {
    title: 'CNBC 2',
    link: `${STATIC_FILE_URL}/685fc58e16b7ac581252464f998b0925.png`,
    width: 40,
    height: 32,
  },
  {
    title: 'Business Insider 2',
    link: `${STATIC_FILE_URL}/a7235f4c38c1500aa22b8894c2ead6a8.png`,
    width: 77,
    height: 24,
  },
  {
    title: 'Forbes 2',
    link: `${STATIC_FILE_URL}/4b7c20eb379918c86e22bc003e8d4ab3.png`,
    width: 61,
    height: 16,
  },
  {
    title: 'Modern Retail 2',
    link: `${STATIC_FILE_URL}/dc81365e388b399ba01a157697239ce5.png`,
    width: 152,
    height: 20,
  },
  {
    title: 'New Bloomberg 2',
    link: `${STATIC_FILE_URL}/4a75f21285efb990682c7f36160b063f.png`,
    width: 130,
    height: 24,
  },
  {
    title: 'Tech Crunch 3',
    link: `${STATIC_FILE_URL}/d65e5b8989922fa0f958538d63bab6cd.svg`,
    width: 138,
    height: 20,
  },
  {
    title: 'CNBC 3',
    link: `${STATIC_FILE_URL}/685fc58e16b7ac581252464f998b0925.png`,
    width: 40,
    height: 32,
  },
  {
    title: 'Business Insider 3',
    link: `${STATIC_FILE_URL}/a7235f4c38c1500aa22b8894c2ead6a8.png`,
    width: 77,
    height: 24,
  },
  {
    title: 'Forbes 3',
    link: `${STATIC_FILE_URL}/4b7c20eb379918c86e22bc003e8d4ab3.png`,
    width: 61,
    height: 16,
  },
  {
    title: 'Modern Retail 3',
    link: `${STATIC_FILE_URL}/dc81365e388b399ba01a157697239ce5.png`,
    width: 152,
    height: 20,
  },
  {
    title: 'New Bloomberg 3',
    link: `${STATIC_FILE_URL}/4a75f21285efb990682c7f36160b063f.png`,
    width: 130,
    height: 24,
  },
];

export const PLATFORMS: IPlatform[] = [
  {
    title: 'Influencer Marketing',
    description: 'Build a powerful affiliate marketing program to grow sales, track performance, and payouts.',
    logo: {
      title: 'Influencer Marketing',
      link: `${STATIC_FILE_URL}/0d5263a6d5bc16685468628e3a6f5eb8.png`,
      width: 286,
      height: 210,
    },
    linkTo: 'affiliate-marketing',
    style: { color: `#4B4B3B` },
    cardStyle: { width: '100%' },
  },
];

export const MEMBERSHIP_CARDS: IMembershipCard[] = [
  {
    title: 'Vetted global manufacturers',
    description: 'Pre-negotiated rates for all our members and software to manage it all.',
    image: {
      link: `${STATIC_FILE_URL}/5304a3ce90bbc8abd91b52cc700cfbbe.png`,
      title: 'Vetted global manufacturers',
      width: 536,
      height: 220,
    },
  },
  {
    title: 'Streamline your operations',
    description: 'Avoid digging through emails, Pietra centralizes all of your communications & invoices. ',
    image: {
      link: `${STATIC_FILE_URL}/9a5cee3e6c416b9cce920fed224390cf.png`,
      title: 'Streamline your operations',
      width: 265,
      height: 220,
    },
  },
];

const existingBrandsSignupImage = `${STATIC_FILE_URL}/481d293a72f988bf05c680e028f2e107.png`;
export const SIGN_UP_LOGOS: Record<BreakpointsType, IFeaturedImage> = {
  '300': {
    width: 368,
    height: 549,
    title: 'Arrae',
    link: existingBrandsSignupImage,
  },
  '640': {
    width: 592,
    height: 549,
    title: 'Arrae',
    link: existingBrandsSignupImage,
  },
  '768': {
    width: 704,
    height: 549,
    title: 'Arrae',
    link: existingBrandsSignupImage,
  },
  '1024': {
    width: 460,
    height: 549,
    title: 'Arrae',
    link: existingBrandsSignupImage,
  },
  '1280': {
    width: 576,
    height: 714,
    title: 'Arrae',
    link: existingBrandsSignupImage,
  },
};

export const CASE_STUDY_LINK: string =
  'https://docs.google.com/presentation/d/e/2PACX-1vSn0UMnZkSXfYtMrNyA2TyZ4-7bNJTTMP449iBgK4ALAlBt8YpuD81GtO1CvYXfSz-Ad--CkYDINj23/pub?start=false&loop=false&delayms=3000&slide=id.g133e6f18103_0_0';
